import {createApplicant, getApplicant, getApplicantList, updateApplicant, createApplicantStatus, statisticApplicant} from '@/services/applicant/index'
import {
  getRecognition,
  updateRecognition,
  createRecognition,
  downloadPdfRecognitionDecision, getRecognitionDecisionDocumentList
} from '@/services/recognition/index'

const state = {
  applicant: {},
  recognition: {},
  activeDocumentSetup:{},
  documentSetupList: [],
  search: {
    list: {
      list_count: 0,
      list_items: []
    },
    filter: {
      page: 1,
      limit: 10,
      name: '',
      institution: null,
      country: {
        id:null,
        name:null
      },
      name_of_foreign_qualification: '',
      name_awarding_institution_original_lang: '',
      city_of_institution: '',
      decision_recognition: '',
      request_protocol_number: '',
      decision_protocol_number: '',
      date_receipt_request_from: '',
      date_receipt_request_to: '',
      received_for_recognition: ''
    }
  }
}

const getters = {
  getApplicant(state) {
    return state.applicant
  },
  getRecognition(state) {
    return state.recognition
  },
  getSearchFilter(state) {
    return state.search.filter
  },
  getSearchList(state) {
    return state.search.list.list_items
  },
  getSearchListCount(state) {
    return state.search.list.list_count
  },
  documentSetupList(state) {
    return state.documentSetupList;
  },
  activeDocumentSetup(state) {
    return state.activeDocumentSetup;
  }

}

const mutations = {
  setApplicant(state, payload) {
    state.applicant = payload
  },
  setApplicantItem(state, {item, value}) {
    state.applicant[item] = value
  },
  setRecognition(state, payload) {
    state.recognition = payload
  },
  setRecognitionItem(state, {item, value}) {
    state.recognition[item] = value
  },
  setSearchListCount(state, count) {
    state.search.list.list_count = count
  },
  setSearchFilterItem(state, {item, value}) {
    state.search.filter[item] = value
  },
  setSearchList(state, list) {
    state.search.list.list_items = list
  },
  setActiveDocumentSetup(state, paylaod) {
    state.activeDocumentSetup = paylaod;
  },
  setDocumentSetupList(state, payload) {
    state.documentSetupList = payload;
  },
  setHTMLData(state, payload) {
    state.activeDocumentSetup.data = payload;
  }

}

const actions = {
  actionSetApplicant({commit}, id) {
    return new Promise((resolve, reject) => {
      getApplicant(id).then(response => {
        commit('setApplicant', response.data)
        resolve(response);  // Let the calling function know that http is done. You may send some data back
      }, error => {
        // http failed, let the calling function know that action did not work out
        reject(error);
      })
    })
  },
  actionResetAplicant({commit}) {
    commit('setApplicant', {})
  },
  actionUpdateApplicant({commit}, payload) {
    return new Promise((resolve, reject) => {
      updateApplicant(payload.id, payload.object)
        .then(response => {
          commit('setApplicant', response.data)
          resolve(response);
        }, error => {
          reject(error);
        })
    })
  },

  actionCreateApplicant({commit}, payload){
    return new Promise((resolve, reject) => {
      createApplicant(payload)
        .then(response => {
          commit('setApplicant', response.data)
          resolve(response);
        }, error => {
          reject(error);
        })
    })
  },
  actionSetRecognition({commit}, id) {
    return new Promise((resolve, reject) => {
      getRecognition(id).then(response => {
        commit('setRecognition', response.data)
        resolve(response);
      }, error => {
        reject(error);
      })
    })
  },
  actionUpdateRecognition({commit}, payload) {
    return new Promise((resolve, reject) => {
      updateRecognition(payload.id,payload.recognition_id, payload.object)
        .then(response => {
          commit('setRecognition', response.data)
          resolve(response);
        }, error => {
          reject(error);
        })
    })
  },
  actionCreateRecognition({commit},payload){
    return new Promise((resolve, reject) => {
      createRecognition(payload.object)
        .then(response => {
          commit('setRecognition', response.data)
          resolve(response);
        }, error => {
          reject(error);
        })
    })
  },
  actionSearch({commit, state}) {
    return new Promise((resolve, reject) => {
      getApplicantList(state.search.filter)
        .then((response) => {
          commit('setSearchList', response.data.items)
          commit('setSearchListCount', response.data.total)
          resolve(response)
        }).catch(error => {
        reject(error)
      })
    })
  },
  actionGetDocumentSetup({commit}, document_id) {
    return new Promise((resolve, reject) => {
      getRecognitionDecisionDocumentList(document_id)
        .then((response) => {
          const documentSetupList = response.data.filter((el) => Number(el.active) === 0);
          const activeDocumentSetup = response.data.find((el) => Number(el.active) === 1);
          commit('setActiveDocumentSetup', activeDocumentSetup)
          commit('setDocumentSetupList', documentSetupList)
          resolve(response)
        }).catch(error => {
        reject(error)
      })
    })
  },
  actionSetHTMLData({commit}, payload) {
    commit('setHTMLData', payload)
  },
  ActionResetSearch({commit}) {
    commit("setSearchFilterItem", {item: "page", value: 1})
    commit("setSearchFilterItem", {item: "limit", value: 10})
    commit("setSearchFilterItem", {item: "name", value: null})
    commit("setSearchFilterItem", {item: "name_of_foreign_qualification", value: null})
    commit("setSearchFilterItem", {item: "name_awarding_institution_original_lang", value: null})
    commit("setSearchFilterItem", {item: "city_of_institution", value: null})
    commit("setSearchFilterItem", {item: "country", value: null})
    commit("setSearchFilterItem", {item: "decision_recognition", value: null})
    commit("setSearchFilterItem", {item: "request_protocol_number", value: null})
    commit("setSearchFilterItem", {item: "decision_protocol_number", value: null})
    commit("setSearchFilterItem", {item: "date_receipt_request_from", value: null})
    commit("setSearchFilterItem", {item: "date_receipt_request_to", value: null})
  }
}
export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
}
